'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_data_types\uff3fdrug$package$__app$data$types_drug$package$DrugRequestId$WithPharmacyId$$anon$36$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lapp_data_types\uff3fdrug$package$__app$data$types_drug$package$DrugRequestId$WithPharmacyId$$anon$36$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_data_types\uff3fdrug$package$__app$data$types_drug$package$DrugRequestId$WithPharmacyId$$anon$36$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_data_types\uff3fdrug$package$__app$data$types_drug$package$DrugRequestId$WithPharmacyId$$anon$36$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq };
//# sourceMappingURL=app.data.types_drug$package$.js.map
